import * as types from "./types";

import INITIAL_STATE from "./init";

export const setDivision = ({
  id = INITIAL_STATE.id,
  title = INITIAL_STATE.title,
  level: { name } = INITIAL_STATE.level,
  benchmark: { target, achieved } = INITIAL_STATE.benchmark,
}) => {
  return {
    type: types.SET_DIVISION,
    payload: {
      id,
      title,
      level: { name },
      benchmark: { target, achieved },
    },
  };
};

export const setBenchmarkAchieved = achieved => {
  return {
    type: types.SET_BENCHMARK_ACHIEVED,
    payload: achieved,
  };
};
